import { UserServiceTariff } from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import { ServicesStore } from '../stores/user/services-store';

@singleton()
export class ServicesStoreFacade {
  originalStore: ServicesStore;

  constructor() {
    this.originalStore = container.resolve(ServicesStore);
  }

  public get service() {
    return this.originalStore.service;
  }

  public get servicesList() {
    return this.originalStore.servicesList;
  }

  public get serviceListRequiredToPresent() {
    return this.originalStore.serviceListRequiredToPresent;
  }

  /**
   * Reset services store to the default state.
   *  @returns void
   */
  @action.bound
  resetStore() {
    return this.originalStore.resetStore();
  }

  /**
   * Get services list by `id`. Your current service will be able in `service` property.
   *  @param id: string
   *  @returns Promise UserServiceTariff
   */
  @action.bound
  async selectService(id: string): Promise<UserServiceTariff | undefined> {
    return this.originalStore.selectService(id);
  }
}
